import React, { useEffect } from 'react';
import DashboardContainer from 'views/Dashboard/DashboardContainer';
import styles from './AccountsList.module.scss';
import { AccountsPageProps, TabsKeys } from 'enums/AccountsListEnums';
import { ReactComponent as LocationIcon } from 'assets/icons/location_line.svg';
import COTabs from 'shared/components/COTabs';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import { getTabs } from './AccountsListHelpers';
import AccountsService from 'services/AccountsService/accounts.service';
import EditLogoModal from 'shared/components/EditLogoModal';
import { useUserContext } from 'context/UserContext';
import Camera from 'assets/icons/camera.svg';
import LoaderAnimation from 'shared/components/LoaderAnimation';
const AccountsList: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [updateLogoModal, setUpdateLogoModal] = React.useState<boolean>(false);

  const { companyImageUrl } = useUserContext();
  const { loading, fetchCompany, company, companyAddress } = AccountsService();
  const currentTab = () => {
    let currentUrl = location.pathname.split('/').length - 1;
    return location.pathname.split('/')[currentUrl];
  };
  const isActiveTab = (key: string) => {
    let currentPage = location.pathname.split('/').length - 1;
    return location.pathname.split('/')[currentPage] === key;
  };
  const handleTabChange = (key: string) =>
    navigate(`${AppRoutes.ACCOUNTS}/${key}`, { replace: true });

  const tabComponents = getTabs({
    isActiveTab,
    handleTabChange,
  });
  const handleOpenUpdateLogoModal = () => setUpdateLogoModal(true);
  const handleCancelUpdateLogoModal = () => setUpdateLogoModal(false);

  useEffect(() => {
    isActiveTab(TabsKeys.USER_DETAILS);
    fetchCompany();
  }, []);

  return (
    <>
      <DashboardContainer>
        <div className={styles.topContainer}>
          <div className={styles.topLeftContainer}>
            <h1>{AccountsPageProps.PAGE_TITLE}</h1>
          </div>
          {loading ? (
            <div className={styles.loaderAnimation}>
              <LoaderAnimation />
            </div>
          ) : (
            <>
              <div className={styles.topCardContainer}>
                <div className={styles.cardRowOne}>
                  <div className={styles.cardRowOneLeft}>
                    <div className={styles.logoContainer}>
                      {company?.image && (
                        <img
                          className={styles.companyLogo}
                          src={companyImageUrl || company?.image}
                          alt={AccountsPageProps.COMPANY_LOGO_ALT}
                        />
                      )}
                    </div>
                    <img
                      onClick={handleOpenUpdateLogoModal}
                      className={styles.companyLogoEdit}
                      src={Camera}
                      alt={AccountsPageProps.COMPANY_LOGO_ALT}
                    />
                    <div className={styles.accountDetailsContainer}>
                      <h3 className={styles.companyName}>{company?.name} . </h3>
                      <h3 className={styles.companyType}>{company?.type}</h3>
                    </div>
                  </div>
                  <div className={styles.cardRowOneRight}>
                    <div className={styles.firstColumn}>
                      <h3 className={styles.rightCategory}>
                        {AccountsPageProps.ROWONE_CATEGORY1}
                      </h3>
                      <h3 className={styles.rightValue}>
                        {company?.revenueRange}
                      </h3>
                    </div>
                    <div className={styles.secondColumn}>
                      <h3 className={styles.rightCategory}>
                        {AccountsPageProps.ROWONE_CATEGORY2}
                      </h3>
                      <h3 className={styles.rightValue}>
                        {company?.productCount}
                      </h3>
                    </div>
                  </div>
                </div>
                <div className={styles.cardRowTwo}>
                  <div className={styles.cardRowTwoLeft}>
                    <LocationIcon className={styles.locationIcon} />
                    <h3 className={styles.companyLocation}>
                      {companyAddress?.city} , {companyAddress?.country}
                    </h3>
                  </div>
                  <div className={styles.cardRowTwoRight}>
                    <div className={styles.firstColumn}>
                      <h3 className={styles.rightCategory}>
                        {AccountsPageProps.ROWTWO_CATEGORY1}
                      </h3>
                      <h3 className={styles.rightValue}>{company?.type}</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <EditLogoModal
                  showModalState={updateLogoModal}
                  handleModalCancel={handleCancelUpdateLogoModal}
                  setUpdateLogoModal={setUpdateLogoModal}
                  data={company}
                />
              </div>
              <div className={styles.secondRowContainer}>
                <div className={styles.tabsContainer}>
                  <COTabs components={tabComponents} activeKey={currentTab()} />
                </div>
              </div>
            </>
          )}
        </div>
      </DashboardContainer>
    </>
  );
};

export default AccountsList;
